module.exports = "/packs/media/images/icons/school-83d5a3d651dca0b3fd2118ce045470c1.svg";